import Axios from 'axios';
import { Payload } from '../constants/payload.model';

const PROPERTIES_ENDPOINT = `${process.env.VUE_APP_ENTITY_ENDPOINT}/entities/`;

export const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};

export default {
    async setEntityProperties(sellerIdentifier, data, propertyIdentifier) {

        const options = new Payload(`${PROPERTIES_ENDPOINT}${sellerIdentifier}/properties/${propertyIdentifier ? propertyIdentifier : ''}`, 'POST', data);

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            throw new Error(error);
        }

    },
    async getEntityProperties(sellerIdentifier, entityType) {

        const options = new Payload(`${PROPERTIES_ENDPOINT}${sellerIdentifier}/properties?type=${entityType}`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            throw new Error(error);
        }
    },
    async removeEntityProperties(sellerIdentifier, propertyIdentifier) {


        const options = new Payload(`${PROPERTIES_ENDPOINT}${sellerIdentifier}/properties/${propertyIdentifier}`, 'DELETE')

        options.withCredentials('x-user-identifier', sellerIdentifier);

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            throw new Error(error);
        }

    },
    async getEntityRelationships(sellerIdentifier, entityType) {

        const options = new Payload(`${PROPERTIES_ENDPOINT}${sellerIdentifier}/relationships?type=${entityType}`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            throw new Error(error);
        }
    },
}; 